





































import { WorkTaskRuleModel } from '@/libs/Api';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { workTaskRulesStore } from '@/libs/work-task-rules/+state/store';
import Page from '@/Page.vue';
import { Component, Prop, VModel, Watch } from 'vue-property-decorator';
import { Guid } from '../functions/guid';
import {Constants} from "@/constants";

@Component({ })
export default class PartyWorkTaskRuleSelect extends Page {

    loading = false;
    search = "";
    debounce: any = null;
    id = Guid.NewGuid();

    @Prop({ default: "" }) label!: string;
    @VModel() innerValue!: string;
    @Prop() placeholder!: string;
    @Prop() readonly!: boolean;
    @Prop() disabled!: boolean;
    @Prop({ default: false }) onlyActive!: boolean;
    @Prop() rules!: any[];
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: false }) hideDetails!: boolean;
    @Prop({ default: false }) partyId!: string;
    @Prop({ default: [] }) except!: string[];
    @Prop({ default: 'catalogueItem.id' }) returnValue!: string;
    @Prop() workTaskRule!: WorkTaskRuleModel;

    @Watch("innerValue")
    innerValueChanged (v: string) {
        this.$emit("rule-change", this.items.firstOrDefault(x => x.id == v));
        this.$emit("change", v);
    }

    @Watch("search")
    searchChanged (v: string, p: string) {
        if (this.innerValue == null && v != p) {
            this.loadItems();
        }
        else if (this.innerValue != null && v != null && (v.length == 1 || v.length == 0)) {
            this.$emit("input", null);
        }
    }

    @Watch("partyId")
    partyIdChanged () {
        this.loadItems();
    }

    get items(): WorkTaskRuleModel[] {
        let items = workTaskRulesStore.useGetter(CrudGetter.Data, this.id) as WorkTaskRuleModel[];
        if (this.except.length > 0) {
          items = items.where(x => !this.except.contains(x.id!)).toArray();
        }
        return items;
    }

    mounted () {
        this.loadItems();
    }

    loadItems () {
        this.loading = true;
        clearTimeout(this.debounce);
        const $this = this;
        this.debounce = setTimeout(() => {
            const filters: any[] = [{
                field: "partyId",
                op: "eq",
                comparand: $this.partyId,
                junction: "and"
            }];
            if ($this.onlyActive) {
                filters.push({
                    field: "workTaskStateId",
                    op: "eq",
                    comparand: Constants.WorkTaskRuleActiveId
                });
            }
            if ($this.innerValue && $this.innerValue.toString().length > 0 && $this.innerValue !== Guid.EmptyGuid()) {
                filters.push({
                    field: $this.returnValue,
                    op: "eq",
                    comparand: $this.innerValue,
                    junction: "and"
                });
            }
            else if (this.search != null && $this.search.length > 0) {
                const searchFilters = [];
                const parts = $this.search.split(" ");
                for (const p of parts) {
                    if (p?.length == 0)
                        continue;
                    searchFilters.push({
                        field: "catalogueItem.name",
                        op: "c",
                        comparand: p.trim(),
                        junction: "or"
                    });
                }
                if (searchFilters.any()) {
                    filters.push({
                        field: "id",
                        op: "wrap",
                        comparand: searchFilters,
                        junction: "and"
                    });
                }
            }
            workTaskRulesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<WorkTaskRuleModel>({ field: "catalogueItem.name", index: 1, order: "asc" }, filters, {
                pageIndex: 1,
                pageSize: 20
            }, false, $this.id));
            $this.subscribe(workTaskRulesStore, CrudReponse.GetAll, $this.id).then(() => {
                // debugger;
                $this.loading = false;
            });
        }, 300)
    }

}
